/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_DairyInputs */

const en_store_dairy = /** @type {(inputs: Store_DairyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dairy`)
};

const de_store_dairy = /** @type {(inputs: Store_DairyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kühlregal`)
};

/**
* | output |
* | --- |
* | "Dairy" |
*
* @param {Store_DairyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_dairy = /** @type {((inputs?: Store_DairyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_DairyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_dairy(inputs)
	return en_store_dairy(inputs)
});